import React from "react";
import Header from "../../common/Header";
import DashBoardSideBar from "../../common/DashBoardSideBar";
import FooterDashBoard from "../../common/FooterDashBoard";
import MyProfleSection from "./components/MyProfleSection";
import DashBoardHeader from "../../common/DashBoardHeader";

const MyProfile = () => {
  return (
    <div className="boxcar-wrapper v2">
         <DashBoardHeader dashBoardHeader={true} />
      <section className="dashboard-widget-two">
        <div className="right-box">
          <DashBoardSideBar />
          <MyProfleSection />
        </div>
      </section>
      <FooterDashBoard />
    </div>
  );
};

export default MyProfile;
